/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Select_All_After_LabelInputs */

const en_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all events after the current selection`)
};

const fr_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez tous les événements postérieurs à la sélection actuelle`)
};

const de_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie alle Ereignisse nach der aktuellen Auswahl aus.`)
};

const it_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutti gli eventi successivi alla selezione corrente`)
};

const ru_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите все события после текущего выбора`)
};

const es_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione todos los eventos después de la selección actual.`)
};

const zh_cn2_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择当前选择之后的所有事件`)
};

const ja_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の選択範囲以降のすべてのイベントを選択します`)
};

const hi_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान चयन के बाद के सभी इवेंट चुनें`)
};

const pt_pt2_context_menu_select_all_after_label = /** @type {(inputs: Context_Menu_Select_All_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione todos os eventos após a seleção atual.`)
};

/**
* | output |
* | --- |
* | "Select all events after the current selection" |
*
* @param {Context_Menu_Select_All_After_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_select_all_after_label = /** @type {((inputs?: Context_Menu_Select_All_After_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Select_All_After_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_select_all_after_label(inputs)
	if (locale === "de") return de_context_menu_select_all_after_label(inputs)
	if (locale === "it") return it_context_menu_select_all_after_label(inputs)
	if (locale === "ru") return ru_context_menu_select_all_after_label(inputs)
	if (locale === "es") return es_context_menu_select_all_after_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_select_all_after_label(inputs)
	if (locale === "ja") return ja_context_menu_select_all_after_label(inputs)
	if (locale === "hi") return hi_context_menu_select_all_after_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_select_all_after_label(inputs)
	return en_context_menu_select_all_after_label(inputs)
});